import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import type { HttpBackendOptions } from 'i18next-http-backend';

import translationEN from './translations-en.json';

const I18N_NAMESPACE = 'translation';
const DEFAULT_LANG = 'en-GB';

const { SIMPLELOCALIZE_URL, NODE_ENV } = process.env;

i18next
  .use(Backend)
  .use(initReactI18next)
  .init<HttpBackendOptions>({
    partialBundledLanguages: true,
    resources: {},
    lng: DEFAULT_LANG,
    // In SimpleLocalize, once you add a key, it is added to all languages.
    // If the translation is empty, the translation exists and it will return an empty string.
    // This makes the fallback language works.
    returnEmptyString: true,
    // Default language
    fallbackLng: DEFAULT_LANG,
    // Enabling debug mode in dev can be quite usefull
    debug: NODE_ENV === 'development',
    // Used to correcty load languages when the slug use the language-COUNTRY format
    load: 'currentOnly',
    // SimpleLocalize URL, obtained from environment variables
    backend: {
      loadPath: SIMPLELOCALIZE_URL
    },
    // Other options
    interpolation: {
      escapeValue: false // react already safes from xss
    },
    defaultNS: I18N_NAMESPACE
  });
i18next.addResourceBundle('en-GB', I18N_NAMESPACE, translationEN, true);
